import { OvhSubsidiary as We, Modal as an, Subtitle as cn, Links as Ht, ActionMenu as un } from "@ovh-ux/manager-react-components";
import { useQuery as ln } from "@tanstack/react-query";
import { getHeaders as fn } from "@ovh-ux/request-tagger";
import _t, { useState as vt, useCallback as Tt, useEffect as Ot, useMemo as pr } from "react";
import { useCookies as dn, CookiesProvider as pn } from "react-cookie";
import { useTranslation as hn, Trans as Vt } from "react-i18next";
import { OdsText as Ue } from "@ovhcloud/ods-components/react";
import { ODS_MODAL_COLOR as mn, ODS_TEXT_PRESET as De, ODS_BUTTON_VARIANT as yn } from "@ovhcloud/ods-components";
import Te from "i18next";
const vn = {
  DEFAULT: "https://www.ovhcloud.com/en-ie/terms-and-conditions/privacy-policy/",
  ASIA: "https://www.ovhcloud.com/en-ca/terms-and-conditions/privacy-policy/",
  AU: "https://www.ovhcloud.com/en-ca/terms-and-conditions/privacy-policy/",
  CA: {
    en: "https://www.ovhcloud.com/en-ca/terms-and-conditions/privacy-policy/",
    fr: "https://www.ovhcloud.com/fr-ca/terms-and-conditions/privacy-policy/"
  },
  CZ: "https://www.ovhcloud.com/en-ie/terms-and-conditions/privacy-policy/",
  DE: "https://www.ovhcloud.com/de/terms-and-conditions/privacy-policy/",
  ES: "https://www.ovhcloud.com/es-es/terms-and-conditions/privacy-policy/",
  EU: "https://www.ovhcloud.com/en-ie/terms-and-conditions/privacy-policy/",
  FI: "https://www.ovhcloud.com/en-ie/terms-and-conditions/privacy-policy/",
  FR: "https://www.ovhcloud.com/fr/terms-and-conditions/privacy-policy/",
  GB: "https://www.ovhcloud.com/en-gb/terms-and-conditions/privacy-policy/",
  IE: "https://www.ovhcloud.com/en-ie/terms-and-conditions/privacy-policy/",
  IN: "https://www.ovhcloud.com/en-in/terms-and-conditions/privacy-policy/",
  IT: "https://www.ovhcloud.com/it/terms-and-conditions/privacy-policy/",
  LT: "https://www.ovhcloud.com/en-ie/terms-and-conditions/privacy-policy/",
  LTE: "https://www.ovhcloud.com/en-ie/terms-and-conditions/privacy-policy/",
  MA: "https://www.ovhcloud.com/fr/terms-and-conditions/privacy-policy/",
  NL: "https://www.ovhcloud.com/nl/terms-and-conditions/privacy-policy/",
  PL: "https://www.ovhcloud.com/pl/terms-and-conditions/privacy-policy/",
  PT: "https://www.ovhcloud.com/pt/terms-and-conditions/privacy-policy/",
  QC: "https://www.ovhcloud.com/fr-ca/terms-and-conditions/privacy-policy/",
  SG: "https://www.ovhcloud.com/en-ca/terms-and-conditions/privacy-policy/",
  SN: "https://www.ovhcloud.com/fr/terms-and-conditions/privacy-policy/",
  TN: "https://www.ovhcloud.com/fr/terms-and-conditions/privacy-policy/",
  US: "https://us.ovhcloud.com/legal/privacy-policy/",
  WE: "https://www.ovhcloud.com/en-ca/terms-and-conditions/privacy-policy/",
  WS: "https://www.ovhcloud.com/en-ca/terms-and-conditions/privacy-policy/"
}, bn = {
  EU: We.IE,
  CA: We.CA,
  US: We.US
}, wn = {
  FR: "https://www.ovh.com/fr/support/documents_legaux/politique_cookies_ovh.xml",
  GB: "https://www.ovh.co.uk/support/termsofservice/cookies_ovh.xml",
  IE: "https://www.ovh.ie/support/termsofservice/cookies_ovh.xml",
  DE: "https://www.ovh.de/support/agb/cookies_ovh.xml",
  ES: "https://www.ovh.es/soporte/documentos_legales/cookies_ovh.xml",
  IT: "https://www.ovh.it/supporto/documenti_legali/cookies_ovh.xml",
  NL: "https://www.ovh.nl/support/algemene_voorwaarden/cookies_ovh.xml",
  PL: "https://www.ovh.pl/pomoc/dokumenty/cookies_ovh.xml",
  PT: "https://www.ovh.pt/suporte/documentos_legais/cookies_ovh.xml",
  SN: "https://www.ovh.sn/support/documents_legaux/politique_cookies_ovh.xml",
  TN: "https://www.ovh.com/tn/support/documents_legaux/politique_cookies_ovh.xml",
  MA: "https://www.ovh.com/ma/support/documents_legaux/politique_cookies_ovh.xml",
  QC: "https://www.ovh.com/ca/fr/support/documents_legaux/cookies_ovh.xml",
  CA: "https://www.ovh.com/ca/en/support/termsofservice/cookies_ovh.xml",
  WE: "https://www.ovh.com/world/support/termsofservice/cookies_ovh.xml",
  WS: "https://www.ovh.com/world/es/soporte/documentos_legales/cookies_ovh.xml",
  AU: "https://www.ovh.com.au/support/termsofservice/cookies_ovh.xml",
  SG: "https://www.ovh.com/sg/support/termsofservice/cookies_ovh.xml",
  ASIA: "https://www.ovh.com/asia/support/termsofservice/cookies_ovh.xml",
  IN: "https://www.ovhcloud.com/en-in/support/termsofservice/cookies_ovh.xml",
  DEFAULT: "https://www.ovh.ie/support/termsofservice/cookies_ovh.xml"
}, gn = "30em", hr = (e, t) => e[t] || e.DEFAULT || "", xs = (e, t) => {
  const [r] = t.split("_"), { CA: n, ...o } = vn, i = hr(o, e);
  return e === "CA" ? n[r] || n.en : i;
};
function mr(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: En } = Object.prototype, { getPrototypeOf: St } = Object, { iterator: st, toStringTag: yr } = Symbol, it = /* @__PURE__ */ ((e) => (t) => {
  const r = En.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), we = (e) => (e = e.toLowerCase(), (t) => it(t) === e), at = (e) => (t) => typeof t === e, { isArray: Me } = Array, Fe = at("undefined");
function Je(e) {
  return e !== null && !Fe(e) && e.constructor !== null && !Fe(e.constructor) && de(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const vr = we("ArrayBuffer");
function Rn(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && vr(e.buffer), t;
}
const _n = at("string"), de = at("function"), br = at("number"), Ye = (e) => e !== null && typeof e == "object", Tn = (e) => e === !0 || e === !1, et = (e) => {
  if (it(e) !== "object")
    return !1;
  const t = St(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(yr in e) && !(st in e);
}, On = (e) => {
  if (!Ye(e) || Je(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Sn = we("Date"), An = we("File"), xn = we("Blob"), Pn = we("FileList"), Cn = (e) => Ye(e) && de(e.pipe), jn = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || de(e.append) && ((t = it(e)) === "formdata" || // detect form-data instance
  t === "object" && de(e.toString) && e.toString() === "[object FormData]"));
}, kn = we("URLSearchParams"), [In, Ln, Un, Dn] = ["ReadableStream", "Request", "Response", "Headers"].map(we), Fn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ke(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), Me(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    if (Je(e))
      return;
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let l;
    for (n = 0; n < a; n++)
      l = i[n], t.call(null, e[l], l, e);
  }
}
function wr(e, t) {
  if (Je(e))
    return null;
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const Ce = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, gr = (e) => !Fe(e) && e !== Ce;
function bt() {
  const { caseless: e, skipUndefined: t } = gr(this) && this || {}, r = {}, n = (o, i) => {
    const a = e && wr(r, i) || i;
    et(r[a]) && et(o) ? r[a] = bt(r[a], o) : et(o) ? r[a] = bt({}, o) : Me(o) ? r[a] = o.slice() : (!t || !Fe(o)) && (r[a] = o);
  };
  for (let o = 0, i = arguments.length; o < i; o++)
    arguments[o] && Ke(arguments[o], n);
  return r;
}
const Mn = (e, t, r, { allOwnKeys: n } = {}) => (Ke(t, (o, i) => {
  r && de(o) ? e[i] = mr(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), Nn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Bn = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, qn = (e, t, r, n) => {
  let o, i, a;
  const l = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!n || n(a, e, t)) && !l[a] && (t[a] = e[a], l[a] = !0);
    e = r !== !1 && St(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Hn = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Vn = (e) => {
  if (!e) return null;
  if (Me(e)) return e;
  let t = e.length;
  if (!br(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, zn = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && St(Uint8Array)), Wn = (e, t) => {
  const n = (e && e[st]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, Jn = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Yn = we("HTMLFormElement"), Kn = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), zt = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Qn = we("RegExp"), Er = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Ke(r, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (n[i] = a || o);
  }), Object.defineProperties(e, n);
}, Gn = (e) => {
  Er(e, (t, r) => {
    if (de(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (de(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Zn = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return Me(e) ? n(e) : n(String(e).split(t)), r;
}, $n = () => {
}, Xn = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function eo(e) {
  return !!(e && de(e.append) && e[yr] === "FormData" && e[st]);
}
const to = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (Ye(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (Je(n))
        return n;
      if (!("toJSON" in n)) {
        t[o] = n;
        const i = Me(n) ? [] : {};
        return Ke(n, (a, l) => {
          const c = r(a, o + 1);
          !Fe(c) && (i[l] = c);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, ro = we("AsyncFunction"), no = (e) => e && (Ye(e) || de(e)) && de(e.then) && de(e.catch), Rr = ((e, t) => e ? setImmediate : t ? ((r, n) => (Ce.addEventListener("message", ({ source: o, data: i }) => {
  o === Ce && i === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), Ce.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  de(Ce.postMessage)
), oo = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ce) : typeof process < "u" && process.nextTick || Rr, so = (e) => e != null && de(e[st]), p = {
  isArray: Me,
  isArrayBuffer: vr,
  isBuffer: Je,
  isFormData: jn,
  isArrayBufferView: Rn,
  isString: _n,
  isNumber: br,
  isBoolean: Tn,
  isObject: Ye,
  isPlainObject: et,
  isEmptyObject: On,
  isReadableStream: In,
  isRequest: Ln,
  isResponse: Un,
  isHeaders: Dn,
  isUndefined: Fe,
  isDate: Sn,
  isFile: An,
  isBlob: xn,
  isRegExp: Qn,
  isFunction: de,
  isStream: Cn,
  isURLSearchParams: kn,
  isTypedArray: zn,
  isFileList: Pn,
  forEach: Ke,
  merge: bt,
  extend: Mn,
  trim: Fn,
  stripBOM: Nn,
  inherits: Bn,
  toFlatObject: qn,
  kindOf: it,
  kindOfTest: we,
  endsWith: Hn,
  toArray: Vn,
  forEachEntry: Wn,
  matchAll: Jn,
  isHTMLForm: Yn,
  hasOwnProperty: zt,
  hasOwnProp: zt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Er,
  freezeMethods: Gn,
  toObjectSet: Zn,
  toCamelCase: Kn,
  noop: $n,
  toFiniteNumber: Xn,
  findKey: wr,
  global: Ce,
  isContextDefined: gr,
  isSpecCompliantForm: eo,
  toJSONObject: to,
  isAsyncFn: ro,
  isThenable: no,
  setImmediate: Rr,
  asap: oo,
  isIterable: so
};
function D(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
p.inherits(D, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: p.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const _r = D.prototype, Tr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Tr[e] = { value: e };
});
Object.defineProperties(D, Tr);
Object.defineProperty(_r, "isAxiosError", { value: !0 });
D.from = (e, t, r, n, o, i) => {
  const a = Object.create(_r);
  p.toFlatObject(e, a, function(f) {
    return f !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", c = t == null && e ? e.code : t;
  return D.call(a, l, c, r, n, o), e && a.cause == null && Object.defineProperty(a, "cause", { value: e, configurable: !0 }), a.name = e && e.name || "Error", i && Object.assign(a, i), a;
};
const io = null;
function wt(e) {
  return p.isPlainObject(e) || p.isArray(e);
}
function Or(e) {
  return p.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Wt(e, t, r) {
  return e ? e.concat(t).map(function(o, i) {
    return o = Or(o), !r && i ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function ao(e) {
  return p.isArray(e) && !e.some(wt);
}
const co = p.toFlatObject(p, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ct(e, t, r) {
  if (!p.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = p.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, y) {
    return !p.isUndefined(y[h]);
  });
  const n = r.metaTokens, o = r.visitor || f, i = r.dots, a = r.indexes, c = (r.Blob || typeof Blob < "u" && Blob) && p.isSpecCompliantForm(t);
  if (!p.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(d) {
    if (d === null) return "";
    if (p.isDate(d))
      return d.toISOString();
    if (p.isBoolean(d))
      return d.toString();
    if (!c && p.isBlob(d))
      throw new D("Blob is not supported. Use a Buffer instead.");
    return p.isArrayBuffer(d) || p.isTypedArray(d) ? c && typeof Blob == "function" ? new Blob([d]) : Buffer.from(d) : d;
  }
  function f(d, h, y) {
    let b = d;
    if (d && !y && typeof d == "object") {
      if (p.endsWith(h, "{}"))
        h = n ? h : h.slice(0, -2), d = JSON.stringify(d);
      else if (p.isArray(d) && ao(d) || (p.isFileList(d) || p.endsWith(h, "[]")) && (b = p.toArray(d)))
        return h = Or(h), b.forEach(function(A, R) {
          !(p.isUndefined(A) || A === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? Wt([h], R, i) : a === null ? h : h + "[]",
            u(A)
          );
        }), !1;
    }
    return wt(d) ? !0 : (t.append(Wt(y, h, i), u(d)), !1);
  }
  const m = [], _ = Object.assign(co, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: wt
  });
  function v(d, h) {
    if (!p.isUndefined(d)) {
      if (m.indexOf(d) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      m.push(d), p.forEach(d, function(b, w) {
        (!(p.isUndefined(b) || b === null) && o.call(
          t,
          b,
          p.isString(w) ? w.trim() : w,
          h,
          _
        )) === !0 && v(b, h ? h.concat(w) : [w]);
      }), m.pop();
    }
  }
  if (!p.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), t;
}
function Jt(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function At(e, t) {
  this._pairs = [], e && ct(e, this, t);
}
const Sr = At.prototype;
Sr.append = function(t, r) {
  this._pairs.push([t, r]);
};
Sr.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, Jt);
  } : Jt;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function uo(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ar(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || uo;
  p.isFunction(r) && (r = {
    serialize: r
  });
  const o = r && r.serialize;
  let i;
  if (o ? i = o(t, r) : i = p.isURLSearchParams(t) ? t.toString() : new At(t, r).toString(n), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Yt {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    p.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const xr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, lo = typeof URLSearchParams < "u" ? URLSearchParams : At, fo = typeof FormData < "u" ? FormData : null, po = typeof Blob < "u" ? Blob : null, ho = {
  isBrowser: !0,
  classes: {
    URLSearchParams: lo,
    FormData: fo,
    Blob: po
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, xt = typeof window < "u" && typeof document < "u", gt = typeof navigator == "object" && navigator || void 0, mo = xt && (!gt || ["ReactNative", "NativeScript", "NS"].indexOf(gt.product) < 0), yo = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", vo = xt && window.location.href || "http://localhost", bo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: xt,
  hasStandardBrowserEnv: mo,
  hasStandardBrowserWebWorkerEnv: yo,
  navigator: gt,
  origin: vo
}, Symbol.toStringTag, { value: "Module" })), se = {
  ...bo,
  ...ho
};
function wo(e, t) {
  return ct(e, new se.classes.URLSearchParams(), {
    visitor: function(r, n, o, i) {
      return se.isNode && p.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function go(e) {
  return p.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Eo(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function Pr(e) {
  function t(r, n, o, i) {
    let a = r[i++];
    if (a === "__proto__") return !0;
    const l = Number.isFinite(+a), c = i >= r.length;
    return a = !a && p.isArray(o) ? o.length : a, c ? (p.hasOwnProp(o, a) ? o[a] = [o[a], n] : o[a] = n, !l) : ((!o[a] || !p.isObject(o[a])) && (o[a] = []), t(r, n, o[a], i) && p.isArray(o[a]) && (o[a] = Eo(o[a])), !l);
  }
  if (p.isFormData(e) && p.isFunction(e.entries)) {
    const r = {};
    return p.forEachEntry(e, (n, o) => {
      t(go(n), o, r, 0);
    }), r;
  }
  return null;
}
function Ro(e, t, r) {
  if (p.isString(e))
    try {
      return (t || JSON.parse)(e), p.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(e);
}
const Qe = {
  transitional: xr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, i = p.isObject(t);
    if (i && p.isHTMLForm(t) && (t = new FormData(t)), p.isFormData(t))
      return o ? JSON.stringify(Pr(t)) : t;
    if (p.isArrayBuffer(t) || p.isBuffer(t) || p.isStream(t) || p.isFile(t) || p.isBlob(t) || p.isReadableStream(t))
      return t;
    if (p.isArrayBufferView(t))
      return t.buffer;
    if (p.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return wo(t, this.formSerializer).toString();
      if ((l = p.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return ct(
          l ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || o ? (r.setContentType("application/json", !1), Ro(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Qe.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (p.isResponse(t) || p.isReadableStream(t))
      return t;
    if (t && p.isString(t) && (n && !this.responseType || o)) {
      const a = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (l) {
        if (a)
          throw l.name === "SyntaxError" ? D.from(l, D.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: se.classes.FormData,
    Blob: se.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
p.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Qe.headers[e] = {};
});
const _o = p.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), To = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), r = a.substring(0, o).trim().toLowerCase(), n = a.substring(o + 1).trim(), !(!r || t[r] && _o[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Kt = Symbol("internals");
function qe(e) {
  return e && String(e).trim().toLowerCase();
}
function tt(e) {
  return e === !1 || e == null ? e : p.isArray(e) ? e.map(tt) : String(e);
}
function Oo(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const So = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ht(e, t, r, n, o) {
  if (p.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!p.isString(t)) {
    if (p.isString(n))
      return t.indexOf(n) !== -1;
    if (p.isRegExp(n))
      return n.test(t);
  }
}
function Ao(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function xo(e, t) {
  const r = p.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, i, a) {
        return this[n].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class pe {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function i(l, c, u) {
      const f = qe(c);
      if (!f)
        throw new Error("header name must be a non-empty string");
      const m = p.findKey(o, f);
      (!m || o[m] === void 0 || u === !0 || u === void 0 && o[m] !== !1) && (o[m || c] = tt(l));
    }
    const a = (l, c) => p.forEach(l, (u, f) => i(u, f, c));
    if (p.isPlainObject(t) || t instanceof this.constructor)
      a(t, r);
    else if (p.isString(t) && (t = t.trim()) && !So(t))
      a(To(t), r);
    else if (p.isObject(t) && p.isIterable(t)) {
      let l = {}, c, u;
      for (const f of t) {
        if (!p.isArray(f))
          throw TypeError("Object iterator must return a key-value pair");
        l[u = f[0]] = (c = l[u]) ? p.isArray(c) ? [...c, f[1]] : [c, f[1]] : f[1];
      }
      a(l, r);
    } else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = qe(t), t) {
      const n = p.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return Oo(o);
        if (p.isFunction(r))
          return r.call(this, o, n);
        if (p.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = qe(t), t) {
      const n = p.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || ht(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function i(a) {
      if (a = qe(a), a) {
        const l = p.findKey(n, a);
        l && (!r || ht(n, n[l], l, r)) && (delete n[l], o = !0);
      }
    }
    return p.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || ht(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return p.forEach(this, (o, i) => {
      const a = p.findKey(n, i);
      if (a) {
        r[a] = tt(o), delete r[i];
        return;
      }
      const l = t ? Ao(i) : String(i).trim();
      l !== i && delete r[i], r[l] = tt(o), n[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return p.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && p.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[Kt] = this[Kt] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(a) {
      const l = qe(a);
      n[l] || (xo(o, a), n[l] = !0);
    }
    return p.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
pe.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
p.reduceDescriptors(pe.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
p.freezeMethods(pe);
function mt(e, t) {
  const r = this || Qe, n = t || r, o = pe.from(n.headers);
  let i = n.data;
  return p.forEach(e, function(l) {
    i = l.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function Cr(e) {
  return !!(e && e.__CANCEL__);
}
function Ne(e, t, r) {
  D.call(this, e ?? "canceled", D.ERR_CANCELED, t, r), this.name = "CanceledError";
}
p.inherits(Ne, D, {
  __CANCEL__: !0
});
function jr(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new D(
    "Request failed with status code " + r.status,
    [D.ERR_BAD_REQUEST, D.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Po(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Co(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const u = Date.now(), f = n[i];
    a || (a = u), r[o] = c, n[o] = u;
    let m = i, _ = 0;
    for (; m !== o; )
      _ += r[m++], m = m % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), u - a < t)
      return;
    const v = f && u - f;
    return v ? Math.round(_ * 1e3 / v) : void 0;
  };
}
function jo(e, t) {
  let r = 0, n = 1e3 / t, o, i;
  const a = (u, f = Date.now()) => {
    r = f, o = null, i && (clearTimeout(i), i = null), e(...u);
  };
  return [(...u) => {
    const f = Date.now(), m = f - r;
    m >= n ? a(u, f) : (o = u, i || (i = setTimeout(() => {
      i = null, a(o);
    }, n - m)));
  }, () => o && a(o)];
}
const ot = (e, t, r = 3) => {
  let n = 0;
  const o = Co(50, 250);
  return jo((i) => {
    const a = i.loaded, l = i.lengthComputable ? i.total : void 0, c = a - n, u = o(c), f = a <= l;
    n = a;
    const m = {
      loaded: a,
      total: l,
      progress: l ? a / l : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && l && f ? (l - a) / u : void 0,
      event: i,
      lengthComputable: l != null,
      [t ? "download" : "upload"]: !0
    };
    e(m);
  }, r);
}, Qt = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Gt = (e) => (...t) => p.asap(() => e(...t)), ko = se.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (r) => (r = new URL(r, se.origin), e.protocol === r.protocol && e.host === r.host && (t || e.port === r.port)))(
  new URL(se.origin),
  se.navigator && /(msie|trident)/i.test(se.navigator.userAgent)
) : () => !0, Io = se.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      p.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), p.isString(n) && a.push("path=" + n), p.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Lo(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Uo(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function kr(e, t, r) {
  let n = !Lo(t);
  return e && (n || r == !1) ? Uo(e, t) : t;
}
const Zt = (e) => e instanceof pe ? { ...e } : e;
function ke(e, t) {
  t = t || {};
  const r = {};
  function n(u, f, m, _) {
    return p.isPlainObject(u) && p.isPlainObject(f) ? p.merge.call({ caseless: _ }, u, f) : p.isPlainObject(f) ? p.merge({}, f) : p.isArray(f) ? f.slice() : f;
  }
  function o(u, f, m, _) {
    if (p.isUndefined(f)) {
      if (!p.isUndefined(u))
        return n(void 0, u, m, _);
    } else return n(u, f, m, _);
  }
  function i(u, f) {
    if (!p.isUndefined(f))
      return n(void 0, f);
  }
  function a(u, f) {
    if (p.isUndefined(f)) {
      if (!p.isUndefined(u))
        return n(void 0, u);
    } else return n(void 0, f);
  }
  function l(u, f, m) {
    if (m in t)
      return n(u, f);
    if (m in e)
      return n(void 0, u);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: l,
    headers: (u, f, m) => o(Zt(u), Zt(f), m, !0)
  };
  return p.forEach(Object.keys({ ...e, ...t }), function(f) {
    const m = c[f] || o, _ = m(e[f], t[f], f);
    p.isUndefined(_) && m !== l || (r[f] = _);
  }), r;
}
const Ir = (e) => {
  const t = ke({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: l } = t;
  if (t.headers = a = pe.from(a), t.url = Ar(kr(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), l && a.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), p.isFormData(r)) {
    if (se.hasStandardBrowserEnv || se.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if (p.isFunction(r.getHeaders)) {
      const c = r.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(c).forEach(([f, m]) => {
        u.includes(f.toLowerCase()) && a.set(f, m);
      });
    }
  }
  if (se.hasStandardBrowserEnv && (n && p.isFunction(n) && (n = n(t)), n || n !== !1 && ko(t.url))) {
    const c = o && i && Io.read(i);
    c && a.set(o, c);
  }
  return t;
}, Do = typeof XMLHttpRequest < "u", Fo = Do && function(e) {
  return new Promise(function(r, n) {
    const o = Ir(e);
    let i = o.data;
    const a = pe.from(o.headers).normalize();
    let { responseType: l, onUploadProgress: c, onDownloadProgress: u } = o, f, m, _, v, d;
    function h() {
      v && v(), d && d(), o.cancelToken && o.cancelToken.unsubscribe(f), o.signal && o.signal.removeEventListener("abort", f);
    }
    let y = new XMLHttpRequest();
    y.open(o.method.toUpperCase(), o.url, !0), y.timeout = o.timeout;
    function b() {
      if (!y)
        return;
      const A = pe.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: A,
        config: e,
        request: y
      };
      jr(function(j) {
        r(j), h();
      }, function(j) {
        n(j), h();
      }, C), y = null;
    }
    "onloadend" in y ? y.onloadend = b : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, y.onabort = function() {
      y && (n(new D("Request aborted", D.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function(R) {
      const C = R && R.message ? R.message : "Network Error", F = new D(C, D.ERR_NETWORK, e, y);
      F.event = R || null, n(F), y = null;
    }, y.ontimeout = function() {
      let R = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const C = o.transitional || xr;
      o.timeoutErrorMessage && (R = o.timeoutErrorMessage), n(new D(
        R,
        C.clarifyTimeoutError ? D.ETIMEDOUT : D.ECONNABORTED,
        e,
        y
      )), y = null;
    }, i === void 0 && a.setContentType(null), "setRequestHeader" in y && p.forEach(a.toJSON(), function(R, C) {
      y.setRequestHeader(C, R);
    }), p.isUndefined(o.withCredentials) || (y.withCredentials = !!o.withCredentials), l && l !== "json" && (y.responseType = o.responseType), u && ([_, d] = ot(u, !0), y.addEventListener("progress", _)), c && y.upload && ([m, v] = ot(c), y.upload.addEventListener("progress", m), y.upload.addEventListener("loadend", v)), (o.cancelToken || o.signal) && (f = (A) => {
      y && (n(!A || A.type ? new Ne(null, e, y) : A), y.abort(), y = null);
    }, o.cancelToken && o.cancelToken.subscribe(f), o.signal && (o.signal.aborted ? f() : o.signal.addEventListener("abort", f)));
    const w = Po(o.url);
    if (w && se.protocols.indexOf(w) === -1) {
      n(new D("Unsupported protocol " + w + ":", D.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(i || null);
  });
}, Mo = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const i = function(u) {
      if (!o) {
        o = !0, l();
        const f = u instanceof Error ? u : this.reason;
        n.abort(f instanceof D ? f : new Ne(f instanceof Error ? f.message : f));
      }
    };
    let a = t && setTimeout(() => {
      a = null, i(new D(`timeout ${t} of ms exceeded`, D.ETIMEDOUT));
    }, t);
    const l = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", i));
    const { signal: c } = n;
    return c.unsubscribe = () => p.asap(l), c;
  }
}, No = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, Bo = async function* (e, t) {
  for await (const r of qo(e))
    yield* No(r, t);
}, qo = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, $t = (e, t, r, n) => {
  const o = Bo(e, t);
  let i = 0, a, l = (c) => {
    a || (a = !0, n && n(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: f } = await o.next();
        if (u) {
          l(), c.close();
          return;
        }
        let m = f.byteLength;
        if (r) {
          let _ = i += m;
          r(_);
        }
        c.enqueue(new Uint8Array(f));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, Xt = 64 * 1024, { isFunction: Ze } = p, Lr = (({ fetch: e, Request: t, Response: r }) => ({
  fetch: e,
  Request: t,
  Response: r
}))(p.global), {
  ReadableStream: er,
  TextEncoder: tr
} = p.global, rr = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Ho = (e) => {
  const { fetch: t, Request: r, Response: n } = Object.assign({}, Lr, e), o = Ze(t), i = Ze(r), a = Ze(n);
  if (!o)
    return !1;
  const l = o && Ze(er), c = o && (typeof tr == "function" ? /* @__PURE__ */ ((d) => (h) => d.encode(h))(new tr()) : async (d) => new Uint8Array(await new r(d).arrayBuffer())), u = i && l && rr(() => {
    let d = !1;
    const h = new r(se.origin, {
      body: new er(),
      method: "POST",
      get duplex() {
        return d = !0, "half";
      }
    }).headers.has("Content-Type");
    return d && !h;
  }), f = a && l && rr(() => p.isReadableStream(new n("").body)), m = {
    stream: f && ((d) => d.body)
  };
  o && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((d) => {
    !m[d] && (m[d] = (h, y) => {
      let b = h && h[d];
      if (b)
        return b.call(h);
      throw new D(`Response type '${d}' is not supported`, D.ERR_NOT_SUPPORT, y);
    });
  });
  const _ = async (d) => {
    if (d == null)
      return 0;
    if (p.isBlob(d))
      return d.size;
    if (p.isSpecCompliantForm(d))
      return (await new r(se.origin, {
        method: "POST",
        body: d
      }).arrayBuffer()).byteLength;
    if (p.isArrayBufferView(d) || p.isArrayBuffer(d))
      return d.byteLength;
    if (p.isURLSearchParams(d) && (d = d + ""), p.isString(d))
      return (await c(d)).byteLength;
  }, v = async (d, h) => {
    const y = p.toFiniteNumber(d.getContentLength());
    return y ?? _(h);
  };
  return async (d) => {
    let {
      url: h,
      method: y,
      data: b,
      signal: w,
      cancelToken: A,
      timeout: R,
      onDownloadProgress: C,
      onUploadProgress: F,
      responseType: j,
      headers: Q,
      withCredentials: T = "same-origin",
      fetchOptions: M
    } = Ir(d);
    j = j ? (j + "").toLowerCase() : "text";
    let N = Mo([w, A && A.toAbortSignal()], R), I = null;
    const P = N && N.unsubscribe && (() => {
      N.unsubscribe();
    });
    let $;
    try {
      if (F && u && y !== "get" && y !== "head" && ($ = await v(Q, b)) !== 0) {
        let ce = new r(h, {
          method: "POST",
          body: b,
          duplex: "half"
        }), le;
        if (p.isFormData(b) && (le = ce.headers.get("content-type")) && Q.setContentType(le), ce.body) {
          const [ge, ve] = Qt(
            $,
            ot(Gt(F))
          );
          b = $t(ce.body, Xt, ge, ve);
        }
      }
      p.isString(T) || (T = T ? "include" : "omit");
      const Z = i && "credentials" in r.prototype, ie = {
        ...M,
        signal: N,
        method: y.toUpperCase(),
        headers: Q.normalize().toJSON(),
        body: b,
        duplex: "half",
        credentials: Z ? T : void 0
      };
      I = i && new r(h, ie);
      let ae = await (i ? t(I, M) : t(h, ie));
      const Re = f && (j === "stream" || j === "response");
      if (f && (C || Re && P)) {
        const ce = {};
        ["status", "statusText", "headers"].forEach((be) => {
          ce[be] = ae[be];
        });
        const le = p.toFiniteNumber(ae.headers.get("content-length")), [ge, ve] = C && Qt(
          le,
          ot(Gt(C), !0)
        ) || [];
        ae = new n(
          $t(ae.body, Xt, ge, () => {
            ve && ve(), P && P();
          }),
          ce
        );
      }
      j = j || "text";
      let Oe = await m[p.findKey(m, j) || "text"](ae, d);
      return !Re && P && P(), await new Promise((ce, le) => {
        jr(ce, le, {
          data: Oe,
          headers: pe.from(ae.headers),
          status: ae.status,
          statusText: ae.statusText,
          config: d,
          request: I
        });
      });
    } catch (Z) {
      throw P && P(), Z && Z.name === "TypeError" && /Load failed|fetch/i.test(Z.message) ? Object.assign(
        new D("Network Error", D.ERR_NETWORK, d, I),
        {
          cause: Z.cause || Z
        }
      ) : D.from(Z, Z && Z.code, d, I);
    }
  };
}, Vo = /* @__PURE__ */ new Map(), Ur = (e) => {
  let t = p.merge.call({
    skipUndefined: !0
  }, Lr, e ? e.env : null);
  const { fetch: r, Request: n, Response: o } = t, i = [
    n,
    o,
    r
  ];
  let a = i.length, l = a, c, u, f = Vo;
  for (; l--; )
    c = i[l], u = f.get(c), u === void 0 && f.set(c, u = l ? /* @__PURE__ */ new Map() : Ho(t)), f = u;
  return u;
};
Ur();
const Et = {
  http: io,
  xhr: Fo,
  fetch: {
    get: Ur
  }
};
p.forEach(Et, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const nr = (e) => `- ${e}`, zo = (e) => p.isFunction(e) || e === null || e === !1, Dr = {
  getAdapter: (e, t) => {
    e = p.isArray(e) ? e : [e];
    const { length: r } = e;
    let n, o;
    const i = {};
    for (let a = 0; a < r; a++) {
      n = e[a];
      let l;
      if (o = n, !zo(n) && (o = Et[(l = String(n)).toLowerCase()], o === void 0))
        throw new D(`Unknown adapter '${l}'`);
      if (o && (p.isFunction(o) || (o = o.get(t))))
        break;
      i[l || "#" + a] = o;
    }
    if (!o) {
      const a = Object.entries(i).map(
        ([c, u]) => `adapter ${c} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? a.length > 1 ? `since :
` + a.map(nr).join(`
`) : " " + nr(a[0]) : "as no adapter specified";
      throw new D(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: Et
};
function yt(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Ne(null, e);
}
function or(e) {
  return yt(e), e.headers = pe.from(e.headers), e.data = mt.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Dr.getAdapter(e.adapter || Qe.adapter, e)(e).then(function(n) {
    return yt(e), n.data = mt.call(
      e,
      e.transformResponse,
      n
    ), n.headers = pe.from(n.headers), n;
  }, function(n) {
    return Cr(n) || (yt(e), n && n.response && (n.response.data = mt.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = pe.from(n.response.headers))), Promise.reject(n);
  });
}
const Fr = "1.12.0", ut = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ut[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const sr = {};
ut.transitional = function(t, r, n) {
  function o(i, a) {
    return "[Axios v" + Fr + "] Transitional option '" + i + "'" + a + (n ? ". " + n : "");
  }
  return (i, a, l) => {
    if (t === !1)
      throw new D(
        o(a, " has been removed" + (r ? " in " + r : "")),
        D.ERR_DEPRECATED
      );
    return r && !sr[a] && (sr[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, a, l) : !0;
  };
};
ut.spelling = function(t) {
  return (r, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function Wo(e, t, r) {
  if (typeof e != "object")
    throw new D("options must be an object", D.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const i = n[o], a = t[i];
    if (a) {
      const l = e[i], c = l === void 0 || a(l, i, e);
      if (c !== !0)
        throw new D("option " + i + " must be " + c, D.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new D("Unknown option " + i, D.ERR_BAD_OPTION);
  }
}
const rt = {
  assertOptions: Wo,
  validators: ut
}, Ee = rt.validators;
class je {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Yt(),
      response: new Yt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = ke(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: i } = r;
    n !== void 0 && rt.assertOptions(n, {
      silentJSONParsing: Ee.transitional(Ee.boolean),
      forcedJSONParsing: Ee.transitional(Ee.boolean),
      clarifyTimeoutError: Ee.transitional(Ee.boolean)
    }, !1), o != null && (p.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : rt.assertOptions(o, {
      encode: Ee.function,
      serialize: Ee.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), rt.assertOptions(r, {
      baseUrl: Ee.spelling("baseURL"),
      withXsrfToken: Ee.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let a = i && p.merge(
      i.common,
      i[r.method]
    );
    i && p.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (d) => {
        delete i[d];
      }
    ), r.headers = pe.concat(a, i);
    const l = [];
    let c = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(r) === !1 || (c = c && h.synchronous, l.unshift(h.fulfilled, h.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(h) {
      u.push(h.fulfilled, h.rejected);
    });
    let f, m = 0, _;
    if (!c) {
      const d = [or.bind(this), void 0];
      for (d.unshift(...l), d.push(...u), _ = d.length, f = Promise.resolve(r); m < _; )
        f = f.then(d[m++], d[m++]);
      return f;
    }
    _ = l.length;
    let v = r;
    for (m = 0; m < _; ) {
      const d = l[m++], h = l[m++];
      try {
        v = d(v);
      } catch (y) {
        h.call(this, y);
        break;
      }
    }
    try {
      f = or.call(this, v);
    } catch (d) {
      return Promise.reject(d);
    }
    for (m = 0, _ = u.length; m < _; )
      f = f.then(u[m++], u[m++]);
    return f;
  }
  getUri(t) {
    t = ke(this.defaults, t);
    const r = kr(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Ar(r, t.params, t.paramsSerializer);
  }
}
p.forEach(["delete", "get", "head", "options"], function(t) {
  je.prototype[t] = function(r, n) {
    return this.request(ke(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
p.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(i, a, l) {
      return this.request(ke(l || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  je.prototype[t] = r(), je.prototype[t + "Form"] = r(!0);
});
class Pt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((l) => {
        n.subscribe(l), i = l;
      }).then(o);
      return a.cancel = function() {
        n.unsubscribe(i);
      }, a;
    }, t(function(i, a, l) {
      n.reason || (n.reason = new Ne(i, a, l), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Pt(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function Jo(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Yo(e) {
  return p.isObject(e) && e.isAxiosError === !0;
}
const Rt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Rt).forEach(([e, t]) => {
  Rt[t] = e;
});
function Mr(e) {
  const t = new je(e), r = mr(je.prototype.request, t);
  return p.extend(r, je.prototype, t, { allOwnKeys: !0 }), p.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return Mr(ke(e, o));
  }, r;
}
const te = Mr(Qe);
te.Axios = je;
te.CanceledError = Ne;
te.CancelToken = Pt;
te.isCancel = Cr;
te.VERSION = Fr;
te.toFormData = ct;
te.AxiosError = D;
te.Cancel = te.CanceledError;
te.all = function(t) {
  return Promise.all(t);
};
te.spread = Jo;
te.isAxiosError = Yo;
te.mergeConfig = ke;
te.AxiosHeaders = pe;
te.formToJSON = (e) => Pr(p.isHTMLForm(e) ? new FormData(e) : e);
te.getAdapter = Dr.getAdapter;
te.HttpStatusCode = Rt;
te.default = te;
const Ko = {
  EU: "https://www.ovh.com/auth/",
  CA: "https://ca.ovh.com/auth/",
  US: "https://us.ovhcloud.com/auth/"
}, Qo = "?action=disconnect", Nr = (e, t) => `${e}${e.indexOf("?") > -1 ? "&" : "?"}${t.join("&")}`, Br = (e) => window.location.assign(e), qr = () => {
  const [, e = ""] = window.location.host.split(".");
  return Ko[`${e.toUpperCase()}`] || "/auth/";
}, Go = (e = "") => {
  const t = [], r = qr();
  return r.indexOf("onsuccess") === -1 && t.push(`onsuccess=${encodeURIComponent(e || window.location.href)}`), r.indexOf("from") === -1 && document.referrer && t.push(`from=${encodeURIComponent(document.referrer)}`), Nr(`${r}${Qo}`, t);
}, Zo = (e = "") => {
  const t = [], r = qr();
  r.indexOf("onsuccess") === -1 && t.push(`onsuccess=${encodeURIComponent(e || window.location.href)}`), Br(Nr(r, t));
}, $o = (e = "") => {
  Br(Go(e));
}, lt = {};
function Xo(e) {
  var o, i, a;
  const { response: t } = e;
  let { status: r } = t || {};
  const n = !!((i = (o = t == null ? void 0 : t.config) == null ? void 0 : o.headers) != null && i.Authorization);
  if (r === 403) {
    const l = (a = t == null ? void 0 : t.data) == null ? void 0 : a.message;
    (l === "This session is forbidden" || l === "This session is invalid") && (r = 401);
  }
  return r === 401 && !n ? ($o(), new Promise(() => {
  })) : r === 471 ? (Zo(), new Promise(() => {
  })) : Promise.reject(e);
}
const Hr = te.create({
  ...lt,
  baseURL: "/engine/apiv6"
}), es = te.create({
  ...lt,
  baseURL: "/engine/2api"
}), ts = te.create({
  ...lt,
  baseURL: "/engine/ws"
}), rs = te.create({
  ...lt,
  baseURL: "/engine/api/v2"
}), ir = { v6: Hr, aapi: es, ws: ts, v2: rs };
Object.keys(ir).forEach((e) => {
  const t = ir[e];
  t.interceptors.request.use((r) => {
    const n = fn(r.baseURL || "");
    return Object.entries(n).forEach(([o, i]) => {
      r.headers[o] = i;
    }), r;
  }), t.interceptors.response.use(void 0, Xo);
});
var ze = /* @__PURE__ */ ((e) => (e[e.DIABLE_2FA = 0] = "DIABLE_2FA", e[e.INDIA = 1] = "INDIA", e[e.FRAUD = 2] = "FRAUD", e[e.GDPR = 3] = "GDPR", e))(ze || {}), ns = /* @__PURE__ */ ((e) => (e.Ok = "ok", e.Open = "open", e.Required = "required", e))(ns || {});
const os = {
  [ze.DIABLE_2FA]: "2FA",
  [ze.INDIA]: "identity",
  [ze.FRAUD]: "fraud",
  [ze.GDPR]: "gdpr"
}, ss = async (e) => {
  const { data: t } = await Hr.get(
    `/me/procedure/${os[e]}`
  );
  return t;
}, Ps = (e, t = {}) => ln({
  ...t,
  queryKey: ["procedure", "status", e],
  queryFn: () => ss(e)
});
var $e = { exports: {} }, He = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ar;
function is() {
  if (ar) return He;
  ar = 1;
  var e = _t, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(l, c, u) {
    var f, m = {}, _ = null, v = null;
    u !== void 0 && (_ = "" + u), c.key !== void 0 && (_ = "" + c.key), c.ref !== void 0 && (v = c.ref);
    for (f in c) n.call(c, f) && !i.hasOwnProperty(f) && (m[f] = c[f]);
    if (l && l.defaultProps) for (f in c = l.defaultProps, c) m[f] === void 0 && (m[f] = c[f]);
    return { $$typeof: t, type: l, key: _, ref: v, props: m, _owner: o.current };
  }
  return He.Fragment = r, He.jsx = a, He.jsxs = a, He;
}
var Ve = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cr;
function as() {
  return cr || (cr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = _t, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), d = Symbol.iterator, h = "@@iterator";
    function y(s) {
      if (s === null || typeof s != "object")
        return null;
      var g = d && s[d] || s[h];
      return typeof g == "function" ? g : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(s) {
      {
        for (var g = arguments.length, S = new Array(g > 1 ? g - 1 : 0), k = 1; k < g; k++)
          S[k - 1] = arguments[k];
        A("error", s, S);
      }
    }
    function A(s, g, S) {
      {
        var k = b.ReactDebugCurrentFrame, G = k.getStackAddendum();
        G !== "" && (g += "%s", S = S.concat([G]));
        var X = S.map(function(K) {
          return String(K);
        });
        X.unshift("Warning: " + g), Function.prototype.apply.call(console[s], console, X);
      }
    }
    var R = !1, C = !1, F = !1, j = !1, Q = !1, T;
    T = Symbol.for("react.module.reference");
    function M(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === n || s === i || Q || s === o || s === u || s === f || j || s === v || R || C || F || typeof s == "object" && s !== null && (s.$$typeof === _ || s.$$typeof === m || s.$$typeof === a || s.$$typeof === l || s.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === T || s.getModuleId !== void 0));
    }
    function N(s, g, S) {
      var k = s.displayName;
      if (k)
        return k;
      var G = g.displayName || g.name || "";
      return G !== "" ? S + "(" + G + ")" : S;
    }
    function I(s) {
      return s.displayName || "Context";
    }
    function P(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case l:
            var g = s;
            return I(g) + ".Consumer";
          case a:
            var S = s;
            return I(S._context) + ".Provider";
          case c:
            return N(s, s.render, "ForwardRef");
          case m:
            var k = s.displayName || null;
            return k !== null ? k : P(s.type) || "Memo";
          case _: {
            var G = s, X = G._payload, K = G._init;
            try {
              return P(K(X));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, Z = 0, ie, ae, Re, Oe, ce, le, ge;
    function ve() {
    }
    ve.__reactDisabledLog = !0;
    function be() {
      {
        if (Z === 0) {
          ie = console.log, ae = console.info, Re = console.warn, Oe = console.error, ce = console.group, le = console.groupCollapsed, ge = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: ve,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, s, {
              value: ie
            }),
            info: $({}, s, {
              value: ae
            }),
            warn: $({}, s, {
              value: Re
            }),
            error: $({}, s, {
              value: Oe
            }),
            group: $({}, s, {
              value: ce
            }),
            groupCollapsed: $({}, s, {
              value: le
            }),
            groupEnd: $({}, s, {
              value: ge
            })
          });
        }
        Z < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var fe = b.ReactCurrentDispatcher, me;
    function Se(s, g, S) {
      {
        if (me === void 0)
          try {
            throw Error();
          } catch (G) {
            var k = G.stack.trim().match(/\n( *(at )?)/);
            me = k && k[1] || "";
          }
        return `
` + me + s;
      }
    }
    var Ae = !1, E;
    {
      var x = typeof WeakMap == "function" ? WeakMap : Map;
      E = new x();
    }
    function q(s, g) {
      if (!s || Ae)
        return "";
      {
        var S = E.get(s);
        if (S !== void 0)
          return S;
      }
      var k;
      Ae = !0;
      var G = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var X;
      X = fe.current, fe.current = null, be();
      try {
        if (g) {
          var K = function() {
            throw Error();
          };
          if (Object.defineProperty(K.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(K, []);
            } catch (_e) {
              k = _e;
            }
            Reflect.construct(s, [], K);
          } else {
            try {
              K.call();
            } catch (_e) {
              k = _e;
            }
            s.call(K.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (_e) {
            k = _e;
          }
          s();
        }
      } catch (_e) {
        if (_e && k && typeof _e.stack == "string") {
          for (var z = _e.stack.split(`
`), ue = k.stack.split(`
`), ne = z.length - 1, oe = ue.length - 1; ne >= 1 && oe >= 0 && z[ne] !== ue[oe]; )
            oe--;
          for (; ne >= 1 && oe >= 0; ne--, oe--)
            if (z[ne] !== ue[oe]) {
              if (ne !== 1 || oe !== 1)
                do
                  if (ne--, oe--, oe < 0 || z[ne] !== ue[oe]) {
                    var ye = `
` + z[ne].replace(" at new ", " at ");
                    return s.displayName && ye.includes("<anonymous>") && (ye = ye.replace("<anonymous>", s.displayName)), typeof s == "function" && E.set(s, ye), ye;
                  }
                while (ne >= 1 && oe >= 0);
              break;
            }
        }
      } finally {
        Ae = !1, fe.current = X, Be(), Error.prepareStackTrace = G;
      }
      var Le = s ? s.displayName || s.name : "", qt = Le ? Se(Le) : "";
      return typeof s == "function" && E.set(s, qt), qt;
    }
    function H(s, g, S) {
      return q(s, !1);
    }
    function L(s) {
      var g = s.prototype;
      return !!(g && g.isReactComponent);
    }
    function V(s, g, S) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return q(s, L(s));
      if (typeof s == "string")
        return Se(s);
      switch (s) {
        case u:
          return Se("Suspense");
        case f:
          return Se("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case c:
            return H(s.render);
          case m:
            return V(s.type, g, S);
          case _: {
            var k = s, G = k._payload, X = k._init;
            try {
              return V(X(G), g, S);
            } catch {
            }
          }
        }
      return "";
    }
    var U = Object.prototype.hasOwnProperty, B = {}, W = b.ReactDebugCurrentFrame;
    function J(s) {
      if (s) {
        var g = s._owner, S = V(s.type, s._source, g ? g.type : null);
        W.setExtraStackFrame(S);
      } else
        W.setExtraStackFrame(null);
    }
    function Y(s, g, S, k, G) {
      {
        var X = Function.call.bind(U);
        for (var K in s)
          if (X(s, K)) {
            var z = void 0;
            try {
              if (typeof s[K] != "function") {
                var ue = Error((k || "React class") + ": " + S + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ue.name = "Invariant Violation", ue;
              }
              z = s[K](g, K, k, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ne) {
              z = ne;
            }
            z && !(z instanceof Error) && (J(G), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", S, K, typeof z), J(null)), z instanceof Error && !(z.message in B) && (B[z.message] = !0, J(G), w("Failed %s type: %s", S, z.message), J(null));
          }
      }
    }
    var O = Array.isArray;
    function re(s) {
      return O(s);
    }
    function he(s) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, S = g && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return S;
      }
    }
    function Ge(s) {
      try {
        return Ct(s), !1;
      } catch {
        return !0;
      }
    }
    function Ct(s) {
      return "" + s;
    }
    function jt(s) {
      if (Ge(s))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", he(s)), Ct(s);
    }
    var kt = b.ReactCurrentOwner, zr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, It, Lt;
    function Wr(s) {
      if (U.call(s, "ref")) {
        var g = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function Jr(s) {
      if (U.call(s, "key")) {
        var g = Object.getOwnPropertyDescriptor(s, "key").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function Yr(s, g) {
      typeof s.ref == "string" && kt.current;
    }
    function Kr(s, g) {
      {
        var S = function() {
          It || (It = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        S.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function Qr(s, g) {
      {
        var S = function() {
          Lt || (Lt = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        S.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var Gr = function(s, g, S, k, G, X, K) {
      var z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: s,
        key: g,
        ref: S,
        props: K,
        // Record the component responsible for creating this element.
        _owner: X
      };
      return z._store = {}, Object.defineProperty(z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: G
      }), Object.freeze && (Object.freeze(z.props), Object.freeze(z)), z;
    };
    function Zr(s, g, S, k, G) {
      {
        var X, K = {}, z = null, ue = null;
        S !== void 0 && (jt(S), z = "" + S), Jr(g) && (jt(g.key), z = "" + g.key), Wr(g) && (ue = g.ref, Yr(g, G));
        for (X in g)
          U.call(g, X) && !zr.hasOwnProperty(X) && (K[X] = g[X]);
        if (s && s.defaultProps) {
          var ne = s.defaultProps;
          for (X in ne)
            K[X] === void 0 && (K[X] = ne[X]);
        }
        if (z || ue) {
          var oe = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          z && Kr(K, oe), ue && Qr(K, oe);
        }
        return Gr(s, z, ue, G, k, kt.current, K);
      }
    }
    var ft = b.ReactCurrentOwner, Ut = b.ReactDebugCurrentFrame;
    function Ie(s) {
      if (s) {
        var g = s._owner, S = V(s.type, s._source, g ? g.type : null);
        Ut.setExtraStackFrame(S);
      } else
        Ut.setExtraStackFrame(null);
    }
    var dt;
    dt = !1;
    function pt(s) {
      return typeof s == "object" && s !== null && s.$$typeof === t;
    }
    function Dt() {
      {
        if (ft.current) {
          var s = P(ft.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function $r(s) {
      return "";
    }
    var Ft = {};
    function Xr(s) {
      {
        var g = Dt();
        if (!g) {
          var S = typeof s == "string" ? s : s.displayName || s.name;
          S && (g = `

Check the top-level render call using <` + S + ">.");
        }
        return g;
      }
    }
    function Mt(s, g) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var S = Xr(g);
        if (Ft[S])
          return;
        Ft[S] = !0;
        var k = "";
        s && s._owner && s._owner !== ft.current && (k = " It was passed a child from " + P(s._owner.type) + "."), Ie(s), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, k), Ie(null);
      }
    }
    function Nt(s, g) {
      {
        if (typeof s != "object")
          return;
        if (re(s))
          for (var S = 0; S < s.length; S++) {
            var k = s[S];
            pt(k) && Mt(k, g);
          }
        else if (pt(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var G = y(s);
          if (typeof G == "function" && G !== s.entries)
            for (var X = G.call(s), K; !(K = X.next()).done; )
              pt(K.value) && Mt(K.value, g);
        }
      }
    }
    function en(s) {
      {
        var g = s.type;
        if (g == null || typeof g == "string")
          return;
        var S;
        if (typeof g == "function")
          S = g.propTypes;
        else if (typeof g == "object" && (g.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        g.$$typeof === m))
          S = g.propTypes;
        else
          return;
        if (S) {
          var k = P(g);
          Y(S, s.props, "prop", k, s);
        } else if (g.PropTypes !== void 0 && !dt) {
          dt = !0;
          var G = P(g);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", G || "Unknown");
        }
        typeof g.getDefaultProps == "function" && !g.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function tn(s) {
      {
        for (var g = Object.keys(s.props), S = 0; S < g.length; S++) {
          var k = g[S];
          if (k !== "children" && k !== "key") {
            Ie(s), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Ie(null);
            break;
          }
        }
        s.ref !== null && (Ie(s), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ie(null));
      }
    }
    function Bt(s, g, S, k, G, X) {
      {
        var K = M(s);
        if (!K) {
          var z = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ue = $r();
          ue ? z += ue : z += Dt();
          var ne;
          s === null ? ne = "null" : re(s) ? ne = "array" : s !== void 0 && s.$$typeof === t ? (ne = "<" + (P(s.type) || "Unknown") + " />", z = " Did you accidentally export a JSX literal instead of a component?") : ne = typeof s, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ne, z);
        }
        var oe = Zr(s, g, S, G, X);
        if (oe == null)
          return oe;
        if (K) {
          var ye = g.children;
          if (ye !== void 0)
            if (k)
              if (re(ye)) {
                for (var Le = 0; Le < ye.length; Le++)
                  Nt(ye[Le], s);
                Object.freeze && Object.freeze(ye);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nt(ye, s);
        }
        return s === n ? tn(oe) : en(oe), oe;
      }
    }
    function rn(s, g, S) {
      return Bt(s, g, S, !0);
    }
    function nn(s, g, S) {
      return Bt(s, g, S, !1);
    }
    var on = nn, sn = rn;
    Ve.Fragment = n, Ve.jsx = on, Ve.jsxs = sn;
  }()), Ve;
}
var ur;
function cs() {
  return ur || (ur = 1, process.env.NODE_ENV === "production" ? $e.exports = is() : $e.exports = as()), $e.exports;
}
var ee = cs();
const Xe = "TC_PRIVACY_CENTER", lr = "2", us = (e, t) => {
  const [r, n] = dn([Xe], {
    doNotParse: !0
  }), [o, i] = vt(
    e !== "US" && !r[Xe]
  ), a = Tt((l) => {
    const c = /* @__PURE__ */ new Date();
    c.setMonth(c.getMonth() + 13), n(
      Xe,
      l ? lr : null,
      {
        path: "/",
        expires: c
      }
    ), i(!1);
  }, []);
  return Ot(() => {
    var l;
    o === !1 && t.onUserConsentFromModal(
      ((l = r[Xe]) == null ? void 0 : l.includes(
        lr
      )) ?? !1
    );
  }, [o]), {
    shouldRequestConsent: o,
    setConsent: a
  };
}, ls = (e, t) => {
  const r = pr(() => t === void 0 ? bn[e] : t in We ? t : We.DEFAULT, [t]);
  return hr(wn, r);
}, fs = "data:image/png;base64,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", xe = "fr_FR", Vr = (e) => {
  let t = e.replace("-", "_");
  return t.includes("_") || (t === "en" ? t = "en_GB" : t = `${t}_${t.toUpperCase()}`), t;
}, ds = (e, t) => async (r) => {
  var o;
  const n = Vr(r);
  if (!e[xe])
    return !1;
  if (!Te.hasResourceBundle(xe, t))
    try {
      console.info(`Loading fallback language: ${xe} for namespace: ${t}`);
      const i = await e[xe]();
      Te.addResources(
        xe,
        t,
        i.default ?? i
      );
    } catch (i) {
      console.error(`Failed to load fallback translations (${xe}):`, i);
    }
  if (!e[n])
    return !1;
  if (n !== xe && !Te.hasResourceBundle(n, t))
    try {
      const i = await ((o = e[n]) == null ? void 0 : o.call(e));
      Te.addResources(n, t, (i == null ? void 0 : i.default) || i);
    } catch (i) {
      console.warn(`Could not load ${n}. Will fallback to ${xe}.`, i);
    }
  return !0;
}, ps = (e, t) => {
  const r = ds(e, t), n = async (o) => {
    const i = Vr(o);
    await r(i);
  };
  Te.isInitialized ? n(Te.language) : Te.on("initialized", () => {
    n(Te.language);
  }), Te.on("languageChanged", (o) => {
    n(o);
  });
}, hs = {
  de_DE: () => import("./Messages_de_DE-CSGXXWSN.mjs"),
  en_GB: () => import("./Messages_en_GB-DlBlY6Io.mjs"),
  es_ES: () => import("./Messages_es_ES-dODDsPaJ.mjs"),
  fr_CA: () => import("./Messages_fr_CA-BY8k-OCr.mjs"),
  fr_FR: () => import("./Messages_fr_FR-BY8k-OCr.mjs"),
  it_IT: () => import("./Messages_it_IT-Dmnz05mt.mjs"),
  pl_PL: () => import("./Messages_pl_PL-DkXN3Dcr.mjs"),
  pt_PT: () => import("./Messages_pt_PT-DVRZE2ZU.mjs")
};
ps(hs, "data-usage-policy");
const ms = ({
  subsidiary: e,
  region: t,
  trackingPlugin: r,
  onModalHidden: n
}) => {
  const { t: o } = hn("data-usage-policy"), { shouldRequestConsent: i, setConsent: a } = us(
    t,
    r
  ), l = ls(t, e), c = Tt((u) => {
    a(u), n == null || n();
  }, []);
  return Ot(() => {
    i === !1 && (n == null || n());
  }, [i]), i && /* @__PURE__ */ ee.jsx(
    an,
    {
      type: mn.information,
      primaryLabel: o("cookie_policy_accept"),
      secondaryLabel: o("cookie_policy_refuse"),
      onPrimaryButtonClick: () => c(!0),
      onSecondaryButtonClick: () => c(!1),
      children: /* @__PURE__ */ ee.jsxs("div", { children: [
        /* @__PURE__ */ ee.jsx("div", { className: "w-full flex justify-center items-center mb-6", children: /* @__PURE__ */ ee.jsx("img", { src: fs, alt: "ovh-cloud-logo" }) }),
        /* @__PURE__ */ ee.jsx("div", { className: "text-center mb-6", children: /* @__PURE__ */ ee.jsx(cn, { children: /* @__PURE__ */ ee.jsx(Ue, { preset: De.heading3, children: o("cookie_policy_title") }) }) }),
        /* @__PURE__ */ ee.jsx("div", { className: "inline-flex mb-6", children: /* @__PURE__ */ ee.jsx(Ue, { preset: De.paragraph, children: /* @__PURE__ */ ee.jsx(
          Vt,
          {
            t: o,
            i18nKey: "cookie_policy_description_1",
            components: {
              Link: /* @__PURE__ */ ee.jsx(
                Ht,
                {
                  href: l,
                  label: o("cookie_policy_description_1_more_informations"),
                  target: "_blank"
                }
              )
            }
          }
        ) }) }),
        /* @__PURE__ */ ee.jsx("ul", { children: /* @__PURE__ */ ee.jsx("li", { children: /* @__PURE__ */ ee.jsx(Ue, { preset: De.paragraph, children: o("cookie_policy_description_3") }) }) }),
        /* @__PURE__ */ ee.jsx(Ue, { preset: De.paragraph, children: o("cookie_policy_description_2") }),
        /* @__PURE__ */ ee.jsxs("div", { className: "mb-4", children: [
          /* @__PURE__ */ ee.jsx(Ue, { preset: De.paragraph, children: o("cookie_policy_description_4") }),
          /* @__PURE__ */ ee.jsx(Ue, { preset: De.paragraph, children: /* @__PURE__ */ ee.jsx(
            Vt,
            {
              t: o,
              i18nKey: "cookie_policy_description_5",
              components: {
                Link: /* @__PURE__ */ ee.jsx(
                  Ht,
                  {
                    href: l,
                    label: o("cookie_policy_description_5_link"),
                    target: "_blank"
                  }
                )
              }
            }
          ) })
        ] })
      ] })
    }
  );
}, Cs = ({
  subsidiary: e,
  region: t,
  trackingPlugin: r
}) => /* @__PURE__ */ ee.jsx(pn, { children: /* @__PURE__ */ ee.jsx(
  ms,
  {
    subsidiary: e,
    region: t,
    trackingPlugin: r
  }
) });
var nt = { exports: {} }, ys = nt.exports, fr;
function vs() {
  return fr || (fr = 1, function(e, t) {
    (function(n, o) {
      e.exports = o(_t);
    })(ys, (r) => (
      /******/
      (() => {
        var n = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            (l, c) => {
              c.match = d, c.parse = h;
              var u = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, f = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, m = /^(?:(min|max)-)?(.+)/, _ = /(em|rem|px|cm|mm|in|pt|pc)?$/, v = /(dpi|dpcm|dppx)?$/;
              function d(A, R) {
                return h(A).some(function(C) {
                  var F = C.inverse, j = C.type === "all" || R.type === C.type;
                  if (j && F || !(j || F))
                    return !1;
                  var Q = C.expressions.every(function(T) {
                    var M = T.feature, N = T.modifier, I = T.value, P = R[M];
                    if (!P)
                      return !1;
                    switch (M) {
                      case "orientation":
                      case "scan":
                        return P.toLowerCase() === I.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        I = w(I), P = w(P);
                        break;
                      case "resolution":
                        I = b(I), P = b(P);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        I = y(I), P = y(P);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        I = parseInt(I, 10) || 1, P = parseInt(P, 10) || 0;
                        break;
                    }
                    switch (N) {
                      case "min":
                        return P >= I;
                      case "max":
                        return P <= I;
                      default:
                        return P === I;
                    }
                  });
                  return Q && !F || !Q && F;
                });
              }
              function h(A) {
                return A.split(",").map(function(R) {
                  R = R.trim();
                  var C = R.match(u), F = C[1], j = C[2], Q = C[3] || "", T = {};
                  return T.inverse = !!F && F.toLowerCase() === "not", T.type = j ? j.toLowerCase() : "all", Q = Q.match(/\([^\)]+\)/g) || [], T.expressions = Q.map(function(M) {
                    var N = M.match(f), I = N[1].toLowerCase().match(m);
                    return {
                      modifier: I[1],
                      feature: I[2],
                      value: N[2]
                    };
                  }), T;
                });
              }
              function y(A) {
                var R = Number(A), C;
                return R || (C = A.match(/^(\d+)\s*\/\s*(\d+)$/), R = C[1] / C[2]), R;
              }
              function b(A) {
                var R = parseFloat(A), C = String(A).match(v)[1];
                switch (C) {
                  case "dpcm":
                    return R / 2.54;
                  case "dppx":
                    return R * 96;
                  default:
                    return R;
                }
              }
              function w(A) {
                var R = parseFloat(A), C = String(A).match(_)[1];
                switch (C) {
                  case "em":
                    return R * 16;
                  case "rem":
                    return R * 16;
                  case "cm":
                    return R * 96 / 2.54;
                  case "mm":
                    return R * 96 / 2.54 / 10;
                  case "in":
                    return R * 96;
                  case "pt":
                    return R * 72;
                  case "pc":
                    return R * 72 / 12;
                  default:
                    return R;
                }
              }
            }
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            (l, c, u) => {
              u.r(c), u.d(c, {
                /* harmony export */
                default: () => h
                /* harmony export */
              });
              var f = /[A-Z]/g, m = /^ms-/, _ = {};
              function v(y) {
                return "-" + y.toLowerCase();
              }
              function d(y) {
                if (_.hasOwnProperty(y))
                  return _[y];
                var b = y.replace(f, v);
                return _[y] = m.test(b) ? "-" + b : b;
              }
              const h = d;
            }
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            (l, c, u) => {
              var f = u(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, m = typeof window < "u" ? window.matchMedia : null;
              function _(d, h, y) {
                var b = this;
                if (m && !y) {
                  var w = m.call(window, d);
                  this.matches = w.matches, this.media = w.media, w.addListener(C);
                } else
                  this.matches = f(d, h), this.media = d;
                this.addListener = A, this.removeListener = R, this.dispose = F;
                function A(j) {
                  w && w.addListener(j);
                }
                function R(j) {
                  w && w.removeListener(j);
                }
                function C(j) {
                  b.matches = j.matches, b.media = j.media;
                }
                function F() {
                  w && w.removeListener(C);
                }
              }
              function v(d, h, y) {
                return new _(d, h, y);
              }
              l.exports = v;
            }
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            (l) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var c = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, f = Object.prototype.propertyIsEnumerable;
              function m(v) {
                if (v == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(v);
              }
              function _() {
                try {
                  if (!Object.assign)
                    return !1;
                  var v = new String("abc");
                  if (v[5] = "de", Object.getOwnPropertyNames(v)[0] === "5")
                    return !1;
                  for (var d = {}, h = 0; h < 10; h++)
                    d["_" + String.fromCharCode(h)] = h;
                  var y = Object.getOwnPropertyNames(d).map(function(w) {
                    return d[w];
                  });
                  if (y.join("") !== "0123456789")
                    return !1;
                  var b = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(w) {
                    b[w] = w;
                  }), Object.keys(Object.assign({}, b)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              l.exports = _() ? Object.assign : function(v, d) {
                for (var h, y = m(v), b, w = 1; w < arguments.length; w++) {
                  h = Object(arguments[w]);
                  for (var A in h)
                    u.call(h, A) && (y[A] = h[A]);
                  if (c) {
                    b = c(h);
                    for (var R = 0; R < b.length; R++)
                      f.call(h, b[R]) && (y[b[R]] = h[b[R]]);
                  }
                }
                return y;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            (l, c, u) => {
              var f = function() {
              };
              {
                var m = u(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), _ = {}, v = u(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                f = function(h) {
                  var y = "Warning: " + h;
                  typeof console < "u" && console.error(y);
                  try {
                    throw new Error(y);
                  } catch {
                  }
                };
              }
              function d(h, y, b, w, A) {
                for (var R in h)
                  if (v(h, R)) {
                    var C;
                    try {
                      if (typeof h[R] != "function") {
                        var F = Error(
                          (w || "React class") + ": " + b + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw F.name = "Invariant Violation", F;
                      }
                      C = h[R](y, R, w, b, null, m);
                    } catch (Q) {
                      C = Q;
                    }
                    if (C && !(C instanceof Error) && f(
                      (w || "React class") + ": type specification of " + b + " `" + R + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof C + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), C instanceof Error && !(C.message in _)) {
                      _[C.message] = !0;
                      var j = A ? A() : "";
                      f(
                        "Failed " + b + " type: " + C.message + (j ?? "")
                      );
                    }
                  }
              }
              d.resetWarningCache = function() {
                _ = {};
              }, l.exports = d;
            }
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            (l, c, u) => {
              var f = u(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), m = u(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), _ = u(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), v = u(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), d = u(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), h = function() {
              };
              h = function(b) {
                var w = "Warning: " + b;
                typeof console < "u" && console.error(w);
                try {
                  throw new Error(w);
                } catch {
                }
              };
              function y() {
                return null;
              }
              l.exports = function(b, w) {
                var A = typeof Symbol == "function" && Symbol.iterator, R = "@@iterator";
                function C(E) {
                  var x = E && (A && E[A] || E[R]);
                  if (typeof x == "function")
                    return x;
                }
                var F = "<<anonymous>>", j = {
                  array: N("array"),
                  bigint: N("bigint"),
                  bool: N("boolean"),
                  func: N("function"),
                  number: N("number"),
                  object: N("object"),
                  string: N("string"),
                  symbol: N("symbol"),
                  any: I(),
                  arrayOf: P,
                  element: $(),
                  elementType: Z(),
                  instanceOf: ie,
                  node: ce(),
                  objectOf: Re,
                  oneOf: ae,
                  oneOfType: Oe,
                  shape: ge,
                  exact: ve
                };
                function Q(E, x) {
                  return E === x ? E !== 0 || 1 / E === 1 / x : E !== E && x !== x;
                }
                function T(E, x) {
                  this.message = E, this.data = x && typeof x == "object" ? x : {}, this.stack = "";
                }
                T.prototype = Error.prototype;
                function M(E) {
                  var x = {}, q = 0;
                  function H(V, U, B, W, J, Y, O) {
                    if (W = W || F, Y = Y || B, O !== _) {
                      if (w) {
                        var re = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw re.name = "Invariant Violation", re;
                      } else if (typeof console < "u") {
                        var he = W + ":" + B;
                        !x[he] && // Avoid spamming the console because they are often not actionable except for lib authors
                        q < 3 && (h(
                          "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + W + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), x[he] = !0, q++);
                      }
                    }
                    return U[B] == null ? V ? U[B] === null ? new T("The " + J + " `" + Y + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new T("The " + J + " `" + Y + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : E(U, B, W, J, Y);
                  }
                  var L = H.bind(null, !1);
                  return L.isRequired = H.bind(null, !0), L;
                }
                function N(E) {
                  function x(q, H, L, V, U, B) {
                    var W = q[H], J = fe(W);
                    if (J !== E) {
                      var Y = me(W);
                      return new T(
                        "Invalid " + V + " `" + U + "` of type " + ("`" + Y + "` supplied to `" + L + "`, expected ") + ("`" + E + "`."),
                        { expectedType: E }
                      );
                    }
                    return null;
                  }
                  return M(x);
                }
                function I() {
                  return M(y);
                }
                function P(E) {
                  function x(q, H, L, V, U) {
                    if (typeof E != "function")
                      return new T("Property `" + U + "` of component `" + L + "` has invalid PropType notation inside arrayOf.");
                    var B = q[H];
                    if (!Array.isArray(B)) {
                      var W = fe(B);
                      return new T("Invalid " + V + " `" + U + "` of type " + ("`" + W + "` supplied to `" + L + "`, expected an array."));
                    }
                    for (var J = 0; J < B.length; J++) {
                      var Y = E(B, J, L, V, U + "[" + J + "]", _);
                      if (Y instanceof Error)
                        return Y;
                    }
                    return null;
                  }
                  return M(x);
                }
                function $() {
                  function E(x, q, H, L, V) {
                    var U = x[q];
                    if (!b(U)) {
                      var B = fe(U);
                      return new T("Invalid " + L + " `" + V + "` of type " + ("`" + B + "` supplied to `" + H + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return M(E);
                }
                function Z() {
                  function E(x, q, H, L, V) {
                    var U = x[q];
                    if (!f.isValidElementType(U)) {
                      var B = fe(U);
                      return new T("Invalid " + L + " `" + V + "` of type " + ("`" + B + "` supplied to `" + H + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return M(E);
                }
                function ie(E) {
                  function x(q, H, L, V, U) {
                    if (!(q[H] instanceof E)) {
                      var B = E.name || F, W = Ae(q[H]);
                      return new T("Invalid " + V + " `" + U + "` of type " + ("`" + W + "` supplied to `" + L + "`, expected ") + ("instance of `" + B + "`."));
                    }
                    return null;
                  }
                  return M(x);
                }
                function ae(E) {
                  if (!Array.isArray(E))
                    return arguments.length > 1 ? h(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : h("Invalid argument supplied to oneOf, expected an array."), y;
                  function x(q, H, L, V, U) {
                    for (var B = q[H], W = 0; W < E.length; W++)
                      if (Q(B, E[W]))
                        return null;
                    var J = JSON.stringify(E, function(O, re) {
                      var he = me(re);
                      return he === "symbol" ? String(re) : re;
                    });
                    return new T("Invalid " + V + " `" + U + "` of value `" + String(B) + "` " + ("supplied to `" + L + "`, expected one of " + J + "."));
                  }
                  return M(x);
                }
                function Re(E) {
                  function x(q, H, L, V, U) {
                    if (typeof E != "function")
                      return new T("Property `" + U + "` of component `" + L + "` has invalid PropType notation inside objectOf.");
                    var B = q[H], W = fe(B);
                    if (W !== "object")
                      return new T("Invalid " + V + " `" + U + "` of type " + ("`" + W + "` supplied to `" + L + "`, expected an object."));
                    for (var J in B)
                      if (v(B, J)) {
                        var Y = E(B, J, L, V, U + "." + J, _);
                        if (Y instanceof Error)
                          return Y;
                      }
                    return null;
                  }
                  return M(x);
                }
                function Oe(E) {
                  if (!Array.isArray(E))
                    return h("Invalid argument supplied to oneOfType, expected an instance of array."), y;
                  for (var x = 0; x < E.length; x++) {
                    var q = E[x];
                    if (typeof q != "function")
                      return h(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Se(q) + " at index " + x + "."
                      ), y;
                  }
                  function H(L, V, U, B, W) {
                    for (var J = [], Y = 0; Y < E.length; Y++) {
                      var O = E[Y], re = O(L, V, U, B, W, _);
                      if (re == null)
                        return null;
                      re.data && v(re.data, "expectedType") && J.push(re.data.expectedType);
                    }
                    var he = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
                    return new T("Invalid " + B + " `" + W + "` supplied to " + ("`" + U + "`" + he + "."));
                  }
                  return M(H);
                }
                function ce() {
                  function E(x, q, H, L, V) {
                    return be(x[q]) ? null : new T("Invalid " + L + " `" + V + "` supplied to " + ("`" + H + "`, expected a ReactNode."));
                  }
                  return M(E);
                }
                function le(E, x, q, H, L) {
                  return new T(
                    (E || "React class") + ": " + x + " type `" + q + "." + H + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + L + "`."
                  );
                }
                function ge(E) {
                  function x(q, H, L, V, U) {
                    var B = q[H], W = fe(B);
                    if (W !== "object")
                      return new T("Invalid " + V + " `" + U + "` of type `" + W + "` " + ("supplied to `" + L + "`, expected `object`."));
                    for (var J in E) {
                      var Y = E[J];
                      if (typeof Y != "function")
                        return le(L, V, U, J, me(Y));
                      var O = Y(B, J, L, V, U + "." + J, _);
                      if (O)
                        return O;
                    }
                    return null;
                  }
                  return M(x);
                }
                function ve(E) {
                  function x(q, H, L, V, U) {
                    var B = q[H], W = fe(B);
                    if (W !== "object")
                      return new T("Invalid " + V + " `" + U + "` of type `" + W + "` " + ("supplied to `" + L + "`, expected `object`."));
                    var J = m({}, q[H], E);
                    for (var Y in J) {
                      var O = E[Y];
                      if (v(E, Y) && typeof O != "function")
                        return le(L, V, U, Y, me(O));
                      if (!O)
                        return new T(
                          "Invalid " + V + " `" + U + "` key `" + Y + "` supplied to `" + L + "`.\nBad object: " + JSON.stringify(q[H], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(E), null, "  ")
                        );
                      var re = O(B, Y, L, V, U + "." + Y, _);
                      if (re)
                        return re;
                    }
                    return null;
                  }
                  return M(x);
                }
                function be(E) {
                  switch (typeof E) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !E;
                    case "object":
                      if (Array.isArray(E))
                        return E.every(be);
                      if (E === null || b(E))
                        return !0;
                      var x = C(E);
                      if (x) {
                        var q = x.call(E), H;
                        if (x !== E.entries) {
                          for (; !(H = q.next()).done; )
                            if (!be(H.value))
                              return !1;
                        } else
                          for (; !(H = q.next()).done; ) {
                            var L = H.value;
                            if (L && !be(L[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function Be(E, x) {
                  return E === "symbol" ? !0 : x ? x["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && x instanceof Symbol : !1;
                }
                function fe(E) {
                  var x = typeof E;
                  return Array.isArray(E) ? "array" : E instanceof RegExp ? "object" : Be(x, E) ? "symbol" : x;
                }
                function me(E) {
                  if (typeof E > "u" || E === null)
                    return "" + E;
                  var x = fe(E);
                  if (x === "object") {
                    if (E instanceof Date)
                      return "date";
                    if (E instanceof RegExp)
                      return "regexp";
                  }
                  return x;
                }
                function Se(E) {
                  var x = me(E);
                  switch (x) {
                    case "array":
                    case "object":
                      return "an " + x;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + x;
                    default:
                      return x;
                  }
                }
                function Ae(E) {
                  return !E.constructor || !E.constructor.name ? F : E.constructor.name;
                }
                return j.checkPropTypes = d, j.resetWarningCache = d.resetWarningCache, j.PropTypes = j, j;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            (l, c, u) => {
              {
                var f = u(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), m = !0;
                l.exports = u(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(f.isElement, m);
              }
            }
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            (l) => {
              var c = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              l.exports = c;
            }
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            (l) => {
              l.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            }
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            (l, c) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var u = typeof Symbol == "function" && Symbol.for, f = u ? Symbol.for("react.element") : 60103, m = u ? Symbol.for("react.portal") : 60106, _ = u ? Symbol.for("react.fragment") : 60107, v = u ? Symbol.for("react.strict_mode") : 60108, d = u ? Symbol.for("react.profiler") : 60114, h = u ? Symbol.for("react.provider") : 60109, y = u ? Symbol.for("react.context") : 60110, b = u ? Symbol.for("react.async_mode") : 60111, w = u ? Symbol.for("react.concurrent_mode") : 60111, A = u ? Symbol.for("react.forward_ref") : 60112, R = u ? Symbol.for("react.suspense") : 60113, C = u ? Symbol.for("react.suspense_list") : 60120, F = u ? Symbol.for("react.memo") : 60115, j = u ? Symbol.for("react.lazy") : 60116, Q = u ? Symbol.for("react.block") : 60121, T = u ? Symbol.for("react.fundamental") : 60117, M = u ? Symbol.for("react.responder") : 60118, N = u ? Symbol.for("react.scope") : 60119;
                function I(O) {
                  return typeof O == "string" || typeof O == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  O === _ || O === w || O === d || O === v || O === R || O === C || typeof O == "object" && O !== null && (O.$$typeof === j || O.$$typeof === F || O.$$typeof === h || O.$$typeof === y || O.$$typeof === A || O.$$typeof === T || O.$$typeof === M || O.$$typeof === N || O.$$typeof === Q);
                }
                function P(O) {
                  if (typeof O == "object" && O !== null) {
                    var re = O.$$typeof;
                    switch (re) {
                      case f:
                        var he = O.type;
                        switch (he) {
                          case b:
                          case w:
                          case _:
                          case d:
                          case v:
                          case R:
                            return he;
                          default:
                            var Ge = he && he.$$typeof;
                            switch (Ge) {
                              case y:
                              case A:
                              case j:
                              case F:
                              case h:
                                return Ge;
                              default:
                                return re;
                            }
                        }
                      case m:
                        return re;
                    }
                  }
                }
                var $ = b, Z = w, ie = y, ae = h, Re = f, Oe = A, ce = _, le = j, ge = F, ve = m, be = d, Be = v, fe = R, me = !1;
                function Se(O) {
                  return me || (me = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Ae(O) || P(O) === b;
                }
                function Ae(O) {
                  return P(O) === w;
                }
                function E(O) {
                  return P(O) === y;
                }
                function x(O) {
                  return P(O) === h;
                }
                function q(O) {
                  return typeof O == "object" && O !== null && O.$$typeof === f;
                }
                function H(O) {
                  return P(O) === A;
                }
                function L(O) {
                  return P(O) === _;
                }
                function V(O) {
                  return P(O) === j;
                }
                function U(O) {
                  return P(O) === F;
                }
                function B(O) {
                  return P(O) === m;
                }
                function W(O) {
                  return P(O) === d;
                }
                function J(O) {
                  return P(O) === v;
                }
                function Y(O) {
                  return P(O) === R;
                }
                c.AsyncMode = $, c.ConcurrentMode = Z, c.ContextConsumer = ie, c.ContextProvider = ae, c.Element = Re, c.ForwardRef = Oe, c.Fragment = ce, c.Lazy = le, c.Memo = ge, c.Portal = ve, c.Profiler = be, c.StrictMode = Be, c.Suspense = fe, c.isAsyncMode = Se, c.isConcurrentMode = Ae, c.isContextConsumer = E, c.isContextProvider = x, c.isElement = q, c.isForwardRef = H, c.isFragment = L, c.isLazy = V, c.isMemo = U, c.isPortal = B, c.isProfiler = W, c.isStrictMode = J, c.isSuspense = Y, c.isValidElementType = I, c.typeOf = P;
              })();
            }
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            (l, c, u) => {
              l.exports = u(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            }
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            (l, c, u) => {
              u.r(c), u.d(c, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  m
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  f
                )
                /* harmony export */
              });
              function f(_, v) {
                if (_ === v)
                  return !0;
                if (!_ || !v)
                  return !1;
                var d = Object.keys(_), h = Object.keys(v), y = d.length;
                if (h.length !== y)
                  return !1;
                for (var b = 0; b < y; b++) {
                  var w = d[b];
                  if (_[w] !== v[w] || !Object.prototype.hasOwnProperty.call(v, w))
                    return !1;
                }
                return !0;
              }
              function m(_, v) {
                if (_ === v)
                  return !0;
                if (!_ || !v)
                  return !1;
                var d = _.length;
                if (v.length !== d)
                  return !1;
                for (var h = 0; h < d; h++)
                  if (_[h] !== v[h])
                    return !1;
                return !0;
              }
            }
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            function(l, c, u) {
              var f = this && this.__rest || function(d, h) {
                var y = {};
                for (var b in d) Object.prototype.hasOwnProperty.call(d, b) && h.indexOf(b) < 0 && (y[b] = d[b]);
                if (d != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var w = 0, b = Object.getOwnPropertySymbols(d); w < b.length; w++)
                    h.indexOf(b[w]) < 0 && Object.prototype.propertyIsEnumerable.call(d, b[w]) && (y[b[w]] = d[b[w]]);
                return y;
              }, m = this && this.__importDefault || function(d) {
                return d && d.__esModule ? d : { default: d };
              };
              Object.defineProperty(c, "__esModule", { value: !0 });
              var _ = m(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), v = function(d) {
                var h = d.children, y = d.device, b = d.onChange, w = f(d, ["children", "device", "onChange"]), A = (0, _.default)(w, y, b);
                return typeof h == "function" ? h(A) : A ? h : null;
              };
              c.default = v;
            }
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            (l, c, u) => {
              Object.defineProperty(c, "__esModule", { value: !0 });
              var f = u(
                /*! react */
                "react"
              ), m = (0, f.createContext)(void 0);
              c.default = m;
            }
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            function(l, c, u) {
              var f = this && this.__importDefault || function(h) {
                return h && h.__esModule ? h : { default: h };
              };
              Object.defineProperty(c, "__esModule", { value: !0 }), c.Context = c.toQuery = c.useMediaQuery = c.default = void 0;
              var m = f(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              c.useMediaQuery = m.default;
              var _ = f(u(
                /*! ./Component */
                "./src/Component.ts"
              ));
              c.default = _.default;
              var v = f(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              c.toQuery = v.default;
              var d = f(u(
                /*! ./Context */
                "./src/Context.ts"
              ));
              c.Context = d.default;
            }
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            function(l, c, u) {
              var f = this && this.__assign || function() {
                return f = Object.assign || function(R) {
                  for (var C, F = 1, j = arguments.length; F < j; F++) {
                    C = arguments[F];
                    for (var Q in C) Object.prototype.hasOwnProperty.call(C, Q) && (R[Q] = C[Q]);
                  }
                  return R;
                }, f.apply(this, arguments);
              }, m = this && this.__rest || function(R, C) {
                var F = {};
                for (var j in R) Object.prototype.hasOwnProperty.call(R, j) && C.indexOf(j) < 0 && (F[j] = R[j]);
                if (R != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var Q = 0, j = Object.getOwnPropertySymbols(R); Q < j.length; Q++)
                    C.indexOf(j[Q]) < 0 && Object.prototype.propertyIsEnumerable.call(R, j[Q]) && (F[j[Q]] = R[j[Q]]);
                return F;
              }, _ = this && this.__importDefault || function(R) {
                return R && R.__esModule ? R : { default: R };
              };
              Object.defineProperty(c, "__esModule", { value: !0 });
              var v = _(u(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), d = v.default.oneOfType([
                v.default.string,
                v.default.number
              ]), h = {
                all: v.default.bool,
                grid: v.default.bool,
                aural: v.default.bool,
                braille: v.default.bool,
                handheld: v.default.bool,
                print: v.default.bool,
                projection: v.default.bool,
                screen: v.default.bool,
                tty: v.default.bool,
                tv: v.default.bool,
                embossed: v.default.bool
              }, y = {
                orientation: v.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: v.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: v.default.string,
                deviceAspectRatio: v.default.string,
                height: d,
                deviceHeight: d,
                width: d,
                deviceWidth: d,
                color: v.default.bool,
                colorIndex: v.default.bool,
                monochrome: v.default.bool,
                resolution: d,
                type: Object.keys(h)
              };
              y.type;
              var b = m(
                y,
                ["type"]
              ), w = f({ minAspectRatio: v.default.string, maxAspectRatio: v.default.string, minDeviceAspectRatio: v.default.string, maxDeviceAspectRatio: v.default.string, minHeight: d, maxHeight: d, minDeviceHeight: d, maxDeviceHeight: d, minWidth: d, maxWidth: d, minDeviceWidth: d, maxDeviceWidth: d, minColor: v.default.number, maxColor: v.default.number, minColorIndex: v.default.number, maxColorIndex: v.default.number, minMonochrome: v.default.number, maxMonochrome: v.default.number, minResolution: d, maxResolution: d }, b), A = f(f({}, h), w);
              c.default = {
                all: A,
                types: h,
                matchers: y,
                features: w
              };
            }
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            function(l, c, u) {
              var f = this && this.__importDefault || function(b) {
                return b && b.__esModule ? b : { default: b };
              };
              Object.defineProperty(c, "__esModule", { value: !0 });
              var m = f(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), _ = f(u(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), v = function(b) {
                return "not ".concat(b);
              }, d = function(b, w) {
                var A = (0, m.default)(b);
                return typeof w == "number" && (w = "".concat(w, "px")), w === !0 ? A : w === !1 ? v(A) : "(".concat(A, ": ").concat(w, ")");
              }, h = function(b) {
                return b.join(" and ");
              }, y = function(b) {
                var w = [];
                return Object.keys(_.default.all).forEach(function(A) {
                  var R = b[A];
                  R != null && w.push(d(A, R));
                }), h(w);
              };
              c.default = y;
            }
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            function(l, c, u) {
              var f = this && this.__importDefault || function(T) {
                return T && T.__esModule ? T : { default: T };
              };
              Object.defineProperty(c, "__esModule", { value: !0 });
              var m = u(
                /*! react */
                "react"
              ), _ = f(u(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), v = f(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), d = u(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), h = f(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), y = f(u(
                /*! ./Context */
                "./src/Context.ts"
              )), b = function(T) {
                return T.query || (0, h.default)(T);
              }, w = function(T) {
                if (T) {
                  var M = Object.keys(T);
                  return M.reduce(function(N, I) {
                    return N[(0, v.default)(I)] = T[I], N;
                  }, {});
                }
              }, A = function() {
                var T = (0, m.useRef)(!1);
                return (0, m.useEffect)(function() {
                  T.current = !0;
                }, []), T.current;
              }, R = function(T) {
                var M = (0, m.useContext)(y.default), N = function() {
                  return w(T) || w(M);
                }, I = (0, m.useState)(N), P = I[0], $ = I[1];
                return (0, m.useEffect)(function() {
                  var Z = N();
                  (0, d.shallowEqualObjects)(P, Z) || $(Z);
                }, [T, M]), P;
              }, C = function(T) {
                var M = function() {
                  return b(T);
                }, N = (0, m.useState)(M), I = N[0], P = N[1];
                return (0, m.useEffect)(function() {
                  var $ = M();
                  I !== $ && P($);
                }, [T]), I;
              }, F = function(T, M) {
                var N = function() {
                  return (0, _.default)(T, M || {}, !!M);
                }, I = (0, m.useState)(N), P = I[0], $ = I[1], Z = A();
                return (0, m.useEffect)(function() {
                  if (Z) {
                    var ie = N();
                    return $(ie), function() {
                      ie && ie.dispose();
                    };
                  }
                }, [T, M]), P;
              }, j = function(T) {
                var M = (0, m.useState)(T.matches), N = M[0], I = M[1];
                return (0, m.useEffect)(function() {
                  var P = function($) {
                    I($.matches);
                  };
                  return T.addListener(P), I(T.matches), function() {
                    T.removeListener(P);
                  };
                }, [T]), N;
              }, Q = function(T, M, N) {
                var I = R(M), P = C(T);
                if (!P)
                  throw new Error("Invalid or missing MediaQuery!");
                var $ = F(P, I), Z = j($), ie = A();
                return (0, m.useEffect)(function() {
                  ie && N && N(Z);
                }, [Z]), (0, m.useEffect)(function() {
                  return function() {
                    $ && $.dispose();
                  };
                }, []), Z;
              };
              c.default = Q;
            }
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            (l) => {
              l.exports = r;
            }
          )
          /******/
        }, o = {};
        function i(l) {
          var c = o[l];
          if (c !== void 0)
            return c.exports;
          var u = o[l] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[l].call(u.exports, u, u.exports, i), u.exports;
        }
        i.d = (l, c) => {
          for (var u in c)
            i.o(c, u) && !i.o(l, u) && Object.defineProperty(l, u, { enumerable: !0, get: c[u] });
        }, i.o = (l, c) => Object.prototype.hasOwnProperty.call(l, c), i.r = (l) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(l, "__esModule", { value: !0 });
        };
        var a = i("./src/index.ts");
        return a;
      })()
    ));
  }(nt)), nt.exports;
}
var bs = /* @__PURE__ */ vs(), Pe;
(function(e) {
  e.ASIA = "ASIA", e.AU = "AU", e.CA = "CA", e.DE = "DE", e.ES = "ES", e.FR = "FR", e.GB = "GB", e.IE = "IE", e.IN = "IN", e.IT = "IT", e.MA = "MA", e.NL = "NL", e.PL = "PL", e.PT = "PT", e.QC = "QC", e.SG = "SG", e.SN = "SN", e.TN = "TN", e.US = "US", e.WE = "WE", e.WS = "WS";
})(Pe || (Pe = {}));
const dr = {
  available: [
    {
      name: "Deutsch",
      key: "de_DE"
    },
    {
      name: "English",
      key: "en_GB"
    },
    {
      name: "Español",
      key: "es_ES"
    },
    {
      name: "Français",
      key: "fr_FR"
    },
    {
      name: "Français (Canadien)",
      key: "fr_CA"
    },
    {
      name: "Italiano",
      key: "it_IT"
    },
    {
      name: "Polski",
      key: "pl_PL"
    },
    {
      name: "Português",
      key: "pt_PT"
    }
  ],
  defaultLoc: "fr_FR",
  fallback: "fr_FR",
  preferred: {
    en: {
      US: Pe.GB,
      CA: Pe.GB,
      EU: Pe.GB
    },
    fr: {
      US: Pe.CA,
      CA: Pe.CA,
      EU: Pe.FR
    }
  }
}, js = ({ onLocalUpdate: e, initialLocal: t = "" }) => {
  const r = bs.useMediaQuery({
    query: `(max-width: ${gn})`
  }), [n, o] = vt(t), [i, a] = vt(
    []
  );
  Ot(() => {
    a(
      dr.available.filter(({ key: f }) => f !== n)
    );
  }, [n]);
  const l = Tt(
    (f) => {
      e(f), o(f);
    },
    [e]
  ), c = () => {
    if (!n) return "";
    const f = dr.available.find(
      (m) => m.key === n
    );
    return f != null && f.key ? r ? f.key.slice(-2) : f.name : "";
  }, u = pr(
    () => i.map((f, m) => ({
      label: f.name,
      onClick: () => l(f.key),
      id: m
    })),
    [i]
  );
  return /* @__PURE__ */ ee.jsx(
    un,
    {
      id: "language-menu",
      items: u,
      label: c(),
      variant: yn.ghost
    }
  );
};
export {
  Cs as DataUsagePolicy,
  js as LanguageMenu,
  ns as ProcedureStatus,
  ze as Procedures,
  xs as usePrivacyPolicyLink,
  Ps as useProcedureStatus
};
